<template>
  <!-- BEGIN navbar-collapse -->
  <div class="collapse d-md-block me-auto" id="top-navbar">
    <div class="navbar-nav">
      <div class="navbar-item dropdown">
        <a
          href="#"
          class="navbar-link dropdown-toggle d-flex align-items-center"
          data-bs-toggle="dropdown"
          title="Cambiar estructura de la vista"
        >
          <i class="fa fa-desktop fa-fw me-2 text-theme"></i>
          <span class="d-lg-inline d-md-none">Vistas</span>
        </a>
        <div class="dropdown-menu">
          <a
            href="javascript:;"
            :class="{ active: selectedView === 'v1' }"
            class="dropdown-item dropdownChooseView"
            @click="navigateToBudgetView('v1')"
            >Presupuestos V1</a
          >
          <a
            href="javascript:;"
            :class="{ active: selectedView === 'v2' }"
            class="dropdown-item dropdownChooseView"
            @click="navigateToBudgetView('v2')"
            >Presupuestos V2</a
          >
          <!--<a href="javascript:;" class="dropdown-item">Algo más aquí</a>
          <div class="dropdown-divider"></div>
          <a href="javascript:;" class="dropdown-item">Link separado</a>
          <div class="dropdown-divider"></div>
          <a href="javascript:;" class="dropdown-item">Otro link separado</a> -->
        </div>
      </div>
      <div class="navbar-item dropdown dropdown-lg">
        <a
          href="#"
          class="navbar-link dropdown-toggle d-flex align-items-center"
          data-bs-toggle="dropdown"
        >
          <i class="fa fa-th-large fa-fw me-1 text-theme"></i>
          <span class="d-lg-inline d-md-none">Filtros</span>
        </a>
        <div
          class="dropdown-menu dropdown-menu-lg text-gray-900"
          @click.native.stop
        >
          <div class="row">
            <!-- BEGIN col-6 -->
            <div class="col">
              <!-- BEGIN nav-tabs -->
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a
                    href="#tab-general"
                    data-bs-toggle="tab"
                    class="nav-link active me-2"
                  >
                    <span class="d-sm-none">Tab 1</span>
                    <span class="d-sm-block d-none">General</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#tab-cliente"
                    data-bs-toggle="tab"
                    class="nav-link me-2"
                  >
                    <span class="d-sm-none">Tab 2</span>
                    <span class="d-sm-block d-none">Cliente</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#tab-control"
                    data-bs-toggle="tab"
                    class="nav-link me-2"
                  >
                    <span class="d-sm-none">Tab 3</span>
                    <span class="d-sm-block d-none">Control</span>
                  </a>
                </li>
              </ul>
              <!-- END nav-tabs -->
              <!-- BEGIN tab-content -->
              <div class="tab-content panel rounded-0 p-3 m-0">
                <!-- BEGIN tab-pane -->
                <div class="tab-pane fade active show" id="tab-general">
                  Panel 1
                </div>
                <!-- END tab-pane -->
                <!-- BEGIN tab-pane -->
                <div class="tab-pane fade" id="tab-cliente">Panel 2</div>
                <!-- END tab-pane -->
                <!-- BEGIN tab-pane -->
                <div class="tab-pane fade" id="tab-control">Panel 3</div>
                <!-- END tab-pane -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Más botones con acciones, sin uso de momento -->
      <!-- <div class="navbar-item">
        <a href="javascript:;" class="navbar-link d-flex align-items-center">
          <i class="fa fa-gem fa-fw me-1 text-theme"></i>
          <span class="d-lg-inline d-md-none">Link</span>
        </a>
      </div> -->
    </div>
  </div>
  <!-- END navbar-collapse -->
</template>
<script setup lang="ts">
// métodos
import { ref } from "vue";
// stores
import { useAppOptionStore } from "@/stores/app-option";
// navegación
import { useRouter } from "vue-router";
// instancias
const router = useRouter();
const appOption = useAppOptionStore();
// variables
const selectedView = ref("v1"); // vista por defecto
// eventos
const emit = defineEmits(["filters-updated"]);
// cambio de vista de presupuestos
const navigateToBudgetView = (view: string) => {
  if (view === "v1") {
    router.push({ name: "presupuestos" });
    appOption.appSelectedMenu = "Presupuestos";
    selectedView.value = view;
  } else if (view === "v2") {
    router.push({ name: "presupuestosV2" });
    appOption.appSelectedMenu = "Presupuestos";
    selectedView.value = view;
  }
};
</script>
<style scoped>
.active.dropdownChooseView {
  font-weight: bold;
  background-color: #98aabb; /* Cambia el color de fondo al estar activo */
}
</style>
